import { render, staticRenderFns } from "./ModalCustasJudiciais.vue?vue&type=template&id=42a85e5f"
import script from "./ModalCustasJudiciais.vue?vue&type=script&lang=js"
export * from "./ModalCustasJudiciais.vue?vue&type=script&lang=js"
import style0 from "./ModalCustasJudiciais.vue?vue&type=style&index=0&id=42a85e5f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports